import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { SelectOption } from "../../../shared/interfaces/select-option";
import { BankingService } from "../../services/banking.service";

export const bankingAllFundsResolver: ResolveFn<SelectOption[]> = () => {
    const service = inject(BankingService);
    return service.getAllFunds() as unknown as SelectOption[];
};